/** @jsxImportSource theme-ui */
import { Spinner, Text, Heading, Flex, Box } from 'theme-ui';

import { TypedUseQueryHookResult } from '@reduxjs/toolkit/dist/query/react/cjs';
import Error from '@/components/Error';

// import Loading from '@/components/Loading';
// import { Header, Message } from 'semantic-ui-react';
// import CorrelationIds from './CorrelationIds';

interface Props {
    queries: TypedUseQueryHookResult<any, any, any>[];
}

const RTKLoader: React.FC<Props> = ({ queries, children }) => {
    queries.some((q) => q.isError);
    return (
        <>
            {queries.every((q) => q.isSuccess) ? (
                children
            ) : queries.some((q) => q.isLoading) ? (
                <Spinner />
            ) : queries.some((q) => q.isError) ? (
                <>
                    {queries
                        .filter((q) => q.isError)
                        .map((q) => (
                            <Box
                                sx={{
                                    h2: {
                                        fontSize: 3,
                                        fontWeight: 'normal',
                                    },
                                }}
                            >
                                <Text color="danger">
                                    {q.endpointName} {' - '}
                                </Text>
                                <Text color="danger">{q.error?.error || q.error?.status}</Text>
                                <Error
                                    error={q.error}
                                    // content={
                                    //     <>
                                    //         <Header>{q.endpointName}</Header>
                                    //         <p>{q.error?.error || q.error?.status}</p>
                                    //         <CorrelationIds />
                                    //     </>
                                    // }
                                />
                            </Box>
                        ))}
                </>
            ) : null}
        </>
    );
};

export default RTKLoader;
